// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.systemIconBase[data-stb-system-icon='current'] {
  flex-shrink: 0;
  font-family: 'Storebrand Symbols';
  font-size: 1rem;
  height: 1rem;
  line-height: 1rem;
  white-space: nowrap;
  width: 1rem;

  /* An option to turn on the legacy System Icons, if necessary. */
  &[data-legacy='true'] {
    font-family: 'System-Icons' !important;
  }

  @media (min-width: 600px) {
    font-size: 1.5rem;
    height: 1.5rem;
    line-height: 1.5rem;
    width: 1.5rem;
  }
}
.iconBase[data-stb-icon='current'] {
  display: inline-flex;

  & svg {
    height: 100%;
    width: 100%;
  }

  & img {
    height: 100%;
    width: 100%;
  }
}
.illustrationBase[data-stb-illustration='current'] {
  display: inline-flex;

  &.autoHeight {
    img {
      height: auto;
      width: auto;
    }
  }

  & img {
    max-width: 100%;
    vertical-align: middle;
  }
}
.alertInlineBase[data-stb-alert-inline='current'] {
  --color-text: var(--p-color-text-primary);
  --color-icon: var(--p-color-icon-primary);

  align-self: start;
  border-radius: var(--p-corner-radius-rem-small);
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  flex-shrink: 0;
  gap: var(--p-spacing-rem-08);

  & .alertTitle {
    color: var(--color-text);
    text-wrap: pretty;

    @media (max-width: 600px) {
      padding-top: 1px;
    }
  }

  & .alertIcon {
    color: var(--color-icon);
  }

  &[data-variant='error'] {
    --color-icon: var(--p-color-icon-error);
    --color-text: var(--p-color-text-error);
  }

  &[data-variant='warning'] {
    --color-icon: var(--p-color-icon-warning);
    --color-text: var(--p-color-text-warning);
  }

  &[data-variant='success'] {
    --color-icon: var(--p-color-icon-success);
    --color-text: var(--p-color-text-success);
  }

  &[data-variant='info'] {
    --color-icon: var(--p-color-icon-info);
    --color-text: var(--p-color-text-info);
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@storeblocks+inline-alert@8.0.0_@storeblocks+assets@6.0.3_react@18.3.1/node_modules/@storeblocks/inline-alert/lib/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;;EAEX,gEAAgE;EAChE;IACE,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,aAAa;EACf;AACF;AACA;EACE,oBAAoB;;EAEpB;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,oBAAoB;;EAEpB;IACE;MACE,YAAY;MACZ,WAAW;IACb;EACF;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;AACA;EACE,yCAAyC;EACzC,yCAAyC;;EAEzC,iBAAiB;EACjB,+CAA+C;EAC/C,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;;EAE5B;IACE,wBAAwB;IACxB,iBAAiB;;IAEjB;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uCAAuC;IACvC,uCAAuC;EACzC;;EAEA;IACE,yCAAyC;IACzC,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;IACzC,yCAAyC;EAC3C;;EAEA;IACE,sCAAsC;IACtC,sCAAsC;EACxC;AACF","sourcesContent":[".systemIconBase[data-stb-system-icon='current'] {\n  flex-shrink: 0;\n  font-family: 'Storebrand Symbols';\n  font-size: 1rem;\n  height: 1rem;\n  line-height: 1rem;\n  white-space: nowrap;\n  width: 1rem;\n\n  /* An option to turn on the legacy System Icons, if necessary. */\n  &[data-legacy='true'] {\n    font-family: 'System-Icons' !important;\n  }\n\n  @media (min-width: 600px) {\n    font-size: 1.5rem;\n    height: 1.5rem;\n    line-height: 1.5rem;\n    width: 1.5rem;\n  }\n}\n.iconBase[data-stb-icon='current'] {\n  display: inline-flex;\n\n  & svg {\n    height: 100%;\n    width: 100%;\n  }\n\n  & img {\n    height: 100%;\n    width: 100%;\n  }\n}\n.illustrationBase[data-stb-illustration='current'] {\n  display: inline-flex;\n\n  &.autoHeight {\n    img {\n      height: auto;\n      width: auto;\n    }\n  }\n\n  & img {\n    max-width: 100%;\n    vertical-align: middle;\n  }\n}\n.alertInlineBase[data-stb-alert-inline='current'] {\n  --color-text: var(--p-color-text-primary);\n  --color-icon: var(--p-color-icon-primary);\n\n  align-self: start;\n  border-radius: var(--p-corner-radius-rem-small);\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  gap: var(--p-spacing-rem-08);\n\n  & .alertTitle {\n    color: var(--color-text);\n    text-wrap: pretty;\n\n    @media (max-width: 600px) {\n      padding-top: 1px;\n    }\n  }\n\n  & .alertIcon {\n    color: var(--color-icon);\n  }\n\n  &[data-variant='error'] {\n    --color-icon: var(--p-color-icon-error);\n    --color-text: var(--p-color-text-error);\n  }\n\n  &[data-variant='warning'] {\n    --color-icon: var(--p-color-icon-warning);\n    --color-text: var(--p-color-text-warning);\n  }\n\n  &[data-variant='success'] {\n    --color-icon: var(--p-color-icon-success);\n    --color-text: var(--p-color-text-success);\n  }\n\n  &[data-variant='info'] {\n    --color-icon: var(--p-color-icon-info);\n    --color-text: var(--p-color-text-info);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
